import Axios from "axios";

export class NotificaService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/notificacion-bvg/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/notificacion-bvg/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/notificacion-bvg/editar`, data).then(res => res.data);
    }

    consultar(id, idp) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/notificacion-bvg/consulta/${id}/${idp}`).then(res => res.data);
    }

    delete(id, idp) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/notificacion-bvg/eliminar/${id}/${idp}`).then(res => res.data);
    }
}
